import {
    UI_ACTION_TYPE,
    UIAction,
    UICreateContentActionParams,
    UIFilterAction,
    UINavigationPageActionParams
} from "../types/chatTypes";
import {getSubRoot} from "../utils/utils";
import {useClipActiveFilters} from "../contexts/application/ClipActiveFilters";
import {usePageSettings} from "../contexts/PageSettingsContext";
import router from '../routes/index';
import {useKeyMomentActiveFilters} from "@/contexts/application/KeyMomentActiveFilters";
import {EVENTS_PAGE_NAME} from "@/constants/globalConstants";

export const useAgentExecutor = () => {


    const {setClipActiveFilters} = useClipActiveFilters();
    const {setKeyMomentActiveFilters} = useKeyMomentActiveFilters()
    const {setCollectionGridShowed} = usePageSettings()


    const executeLogicClipCreation = (action: UIAction ): void => {
    }

    const executeNavigation = (action: UIAction ): void => {
        const basePath = getSubRoot(window.location.pathname)
        const actionParams = action.params as UINavigationPageActionParams
        let targetPath = ``
        if (actionParams.url === `/${EVENTS_PAGE_NAME}/processing`){
            targetPath = `${basePath}${actionParams.url}?eventId=${actionParams.event_id}`
        }else if (actionParams.url === '/newcollection'){
            targetPath = `${basePath}/${actionParams.collection_type}${actionParams.url}`
        }else if (actionParams.url === '/contentAggregation'){
            targetPath = `${basePath}${actionParams.url}/${actionParams.content_type ? actionParams.content_type.toLowerCase() : ''}`
        }
        else{
            targetPath = `${basePath}${actionParams.url}`
        }
        router.navigate(targetPath);
    }

    const executePostMaterialization = (action: UIAction ): void => {
        const basePath = getSubRoot(window.location.pathname)
        let targetPath = `${basePath}/renderingjob`
        router.navigate(targetPath);
    }

    const executeFilterAction = (action: UIAction ): void => {

    }

    const executeAction = (action: UIAction) => {
        switch (action.type) {
            case UI_ACTION_TYPE.CREATE_CONTENT:
                executeLogicClipCreation(action)
                break;
            case UI_ACTION_TYPE.NAVIGATION_PAGE:
                executeNavigation(action)
                break;
            case UI_ACTION_TYPE.FILTER:
                executeFilterAction(action)
                break;
            case UI_ACTION_TYPE.POST_MATERIALIZATION:
                executePostMaterialization(action)
                break;
            default:
                console.warn(`AI Action type not recognized`, action);
        }
    };

    const executeActions = (actions: UIAction[]) => {
        for (const action of actions) {
            executeAction(action)
        }
    }


    return { executeActions };
};